import { SET_GENERAL_SETTING, SET_SMS_CONFIGURATION } from './constant';
import { api } from '../../service';

/**
 * Get general setting.
 *
 * @returns
 */
// eslint-disable-next-line import/prefer-default-export
export const getGeneralSetting = () => async (dispatch) => {
  try {
    const { data } = await api.get('/settings');

    if (data) {
      // Dispatch Service List Info.
      dispatch({ type: SET_GENERAL_SETTING, payload: data.data });
      
      // Use the pre-calculated freguesias list from backend if available, 
      // otherwise fallback to parsing regions (backward compatibility)
      const freguesiasList = data.data.freguesias || (data.data.regions 
        ? data.data.regions.flatMap(r => 
            r.freguesias.map(f => ({ concelho: r.concelho, freguesia: f, designacao: `${r.concelho} - ${f}` }))
          )
        : []);

      const parsedData = {
        ...data.data,
        freguesias: freguesiasList,
        useFreguesias: freguesiasList.length > 0,
      };
      
      return parsedData;
    }
    return data.data;
  } catch (error) {
    const message = error.response
      ? error.response.data.moreInformation.error
      : { message: error.message };
    throw new Error(message);
  }
};

export const getTranslations = () => async (dispatch) => {
  try {
    const { data } = await api.get('/translations_backoffice');

    if (data) {
      // Dispatch Service List Info.
      dispatch({ type: SET_GENERAL_SETTING, payload: data });
    }
    return data;
  } catch (error) {
    const message = error.response
      ? error.response.data.moreInformation.error
      : { message: error.message };
    throw new Error(message);
  }
};

/**
 * Update general setting.
 *
 * @param {object} values
 * @param {string} serviceID
 * @returns
 */
export const updateGeneralSettings = (values) => async () => {
  try {
    const { data } = await api.patch(`/settings`, values);

    return data.data;
  } catch (error) {
    const message = error.response
      ? error.response.data.moreInformation.error
      : { message: error.message };
    throw new Error(message);
  }
};

export const getClientAnnouncement = () => async () => {
  try {
    const { data } = await api.get('/backoffice/client-announcement');
    return data.data;
  } catch (error) {
    const message = error.response
      ? error.response.data.moreInformation.error
      : error.message;
    throw new Error(message);
  }
};

export const updateClientAnnouncement = (values) => async () => {
  try {
    const { data } = await api.patch(
      '/backoffice/client-announcement',
      values
    );
    return data.data;
  } catch (error) {
    const message = error.response
      ? error.response.data.moreInformation.error
      : error.message;
    throw new Error(message);
  }
};

export const updateTranslations = (values) => async () => {
  try {
    const { data } = await api.patch(`/translations_backoffice`, values);

    return data;
  } catch (error) {
    const message = error.response
      ? error.response.data.moreInformation.error
      : { message: error.message };
    throw new Error(message);
  }
};

/**
 * Update general service setting.
 *
 * @param {object} payload - Contains values, concelhos, useFreguesias, freguesias
 * @returns
 */
export const updateGeneralServiceSettings = (payload) => async () => {
  try {
    // Structure the payload for the API - concelhos and freguesias at root level
    const requestData = {
      values: payload.values,
      concelhos: payload.concelhos,
      freguesias: payload.useFreguesias ? payload.freguesias : [],
      notify_subscribers: !!payload.notifySubscribers,
    };
    
    const { data } = await api.patch(`/service_settings`, requestData);

    return data.data;
  } catch (error) {
    const message = error.response
      ? error.response.data.moreInformation.error
      : { message: error.message };
    throw new Error(message);
  }
};

/**
 * Count pending no_coverage subscribers for a (concelho, freguesia) pair.
 *
 * @param {object} region
 * @returns
 */
export const getPendingCoverageSubscribers = (region) => async () => {
  try {
    const params = new URLSearchParams({
      reason: 'no_coverage',
      concelho: region.concelho || '',
    });
    if (region.freguesia) params.set('freguesia', region.freguesia);
    const { data } = await api.get(`/backoffice/notification-requests/pending?${params.toString()}`);
    return data.data;
  } catch (error) {
    const message = error.response
      ? error.response.data.moreInformation.error
      : { message: error.message };
    throw new Error(message);
  }
};

/**
 * Get sms configuration.
 *
 * @returns
 */
export const getSmsConfiguration = () => async (dispatch) => {
  try {
    const { data } = await api.get('/backoffice/smssettings');

    if (data) {
      // Dispatch Service List Info.
      dispatch({ type: SET_SMS_CONFIGURATION, payload: data.data });
    }
    return data.data;
  } catch (error) {
    const message = error.response
      ? error.response.data.moreInformation.error
      : { message: error.message };
    throw new Error(message);
  }
};

/**
 * Update sms configuration.
 *
 * @param {object} values
 * @returns
 */
export const updateSmsConfiguration = (values) => async () => {
  try {
    const { data } = await api.patch('/backoffice/smssettings', values);

    return data.data;
  } catch (error) {
    const message = error.response
      ? error.response.data.moreInformation.error
      : { message: error.message };
    throw new Error(message);
  }
};
